import { getErrorText } from '../../../common/api/errors'

/** Text of a refused callback resend for the confirmation dialog: the backend sentence or what the page threw. */
export const callbackResendErrorText = (error: unknown): string => {
  const reason = error instanceof Error ? error.message : getErrorText(error, 'сервис вернул ошибку', { withFieldName: false })

  return `Не удалось отправить КБ: ${reason}`
}
